import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import {
  aDayInMs,
  getDateKey,
  getTodayDate
} from '../planner-utils/date-time-helper';
import { plannerItemTypes } from '../planner-constants';
import DayTitle from '../PlannerCards/DayTitle';
import Timeline from '../PlannerCards/Timeline';
import { DefaultLoaderSkeleton } from '../PlannerCards/PlannerElements';

const Wrapper = styled.div`
  grid-column: 1/12;
  padding-right: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoMobile} {
    max-width: 100%;
  }
`;

const plannerItemTypeComponentMap = {
  [plannerItemTypes.DAY_TITLE]: DayTitle,
  [plannerItemTypes.TIMELINE]: Timeline,
  [plannerItemTypes.SKELETON_LOADER]: DefaultLoaderSkeleton
};

const LoaderSkeleton = () => {
  const today = getTodayDate().date;
  const yesterday = new Date(Date.now() - aDayInMs);
  const tomorrow = new Date(Date.now() + aDayInMs);

  const threeDaysTimeline = [yesterday, today, tomorrow].map((date) => {
    const dateKey = getDateKey(date);

    return {
      height: 188,
      dateKey,
      metaItems: [
        {
          dateKey,
          date: new Date(date).getTime(),
          plannerItemType: plannerItemTypes.DAY_TITLE
        },
        {
          plannerItemType: plannerItemTypes.TIMELINE,
          title: '6 AM'
        },
        {
          plannerItemType: plannerItemTypes.SKELETON_LOADER
        },
        {
          plannerItemType: plannerItemTypes.TIMELINE,
          title: '11 PM'
        }
      ]
    };
  });

  return (
    <Wrapper>
      {threeDaysTimeline.map((day) => (
        <>
          {day.metaItems.map((metaItem) => {
            const { plannerItemType } = metaItem;
            const Card = plannerItemTypeComponentMap[plannerItemType];
            if (Card) return <Card metaItem={metaItem} />;
            return null;
          })}
        </>
      ))}
    </Wrapper>
  );
};

export default LoaderSkeleton;
